import config from '../config';

/**
 * Fetch all reward entries.
 * @returns {Promise<Object[]>} List of rewards.
 */
export const getAllRewards = async () => {
  const response = await fetch(`${config.apiUrl}/rewards`);
  if (!response.ok) throw new Error('Failed to fetch rewards');
  return response.json();
};

/**
 * Fetch rewards by partner user ID.
 * @param {string|number} partnerId
 * @returns {Promise<Object[]>}
 */
export const getRewardsByPartnerId = async (partnerId) => {
  const response = await fetch(`${config.apiUrl}/rewards/partner/${encodeURIComponent(partnerId)}`);
  if (!response.ok) throw new Error('Failed to fetch rewards by partner ID');
  return response.json();
};

/**
 * Fetch all user reward records, optionally filtered by partner ID.
 * @param {string|number} [partnerId]
 * @returns {Promise<Object[]>}
 */
export const getAllUserRewards = async (partnerId) => {
  const query = partnerId ? `?partnerid=${encodeURIComponent(partnerId)}` : '';
  const response = await fetch(`${config.apiUrl}/user-rewards${query}`);
  if (!response.ok) throw new Error('Failed to fetch user rewards');
  return response.json();
};

/**
 * Update a user reward record by ID.
 * @param {string|number} id
 * @param {Object} data
 * @returns {Promise<Object>}
 */
export const updateUserReward = async (id, data) => {
  const response = await fetch(`${config.apiUrl}/user-rewards/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to update user reward');
  }

  return response.json();
};
